import { render } from "./AddOnTestsOrders.vue?vue&type=template&id=35a61a74"
import script from "./AddOnTestsOrders.vue?vue&type=script&lang=js"
export * from "./AddOnTestsOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/AddOnTestsOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "35a61a74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('35a61a74', __exports__)) {
    console.log('reload')
    api.reload('35a61a74', __exports__)
  }
  
  module.hot.accept("./AddOnTestsOrders.vue?vue&type=template&id=35a61a74", () => {
    console.log('re-render')
    api.rerender('35a61a74', render)
  })

}


export default __exports__